import { render, staticRenderFns } from "./TabConfigureAndPublish.vue?vue&type=template&id=315b580e&scoped=true&"
import script from "./TabConfigureAndPublish.vue?vue&type=script&lang=js&"
export * from "./TabConfigureAndPublish.vue?vue&type=script&lang=js&"
import style0 from "./TabConfigureAndPublish.vue?vue&type=style&index=0&id=315b580e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b580e",
  null
  
)

component.options.__file = "TabConfigureAndPublish.vue"
export default component.exports